import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
import { saveAs } from 'file-saver';
import { getRound } from './number.helper';
export const PDF_CONSTANTS = {
    TYPE: 'image/png',
    IMAGE_EXTENSION: 'PNG'
};
export const capitalizeFirstLetter = ([first, ...rest], locale = navigator.language) =>
    first === undefined ? '' : first.toLocaleUpperCase(locale) + rest.join('');

export const getFirsLetterOfNameAndCaste = (name) => {
    if (!name) return '';
    const splittedName = name.toString().split(' ');
    return splittedName
        .map((nameItem, index) => {
            if (index < 2) return nameItem.charAt(0).toLocaleUpperCase();
            else return '';
        })
        .join('');
};

export const getAttachmentType = (key) => {
    const splittedKey = key.split('.');
    return splittedKey[splittedKey.length - 1];
};

export const convertBytesToKb = (bytesData) => {
    if (!bytesData) return 0;
    return bytesData / 1000;
};

export const convertBytes = (bytes) => {
    let value, unit;

    if (bytes < 1024) {
        value = bytes;
        unit = 'B';
    } else if (bytes < 1024 * 1024) {
        value = bytes / 1024;
        unit = 'KB';
    } else if (bytes < 1024 * 1024 * 1024) {
        value = bytes / (1024 * 1024);
        unit = 'MB';
    } else if (bytes < 1024 * 1024 * 1024 * 1024) {
        value = bytes / (1024 * 1024 * 1024);
        unit = 'GB';
    } else {
        value = bytes / (1024 * 1024 * 1024 * 1024);
        unit = 'TB';
    }

    // Determine if value has significant decimals
    const fixedValue = value % 1 === 0 ? parseFloat(value).toFixed(0) : parseFloat(value).toFixed(2);

    return `${fixedValue} ${unit}`;
};
export const convertBytesCeiled = (bytes) => {
    if (bytes < 1024) {
        return Math.ceil(bytes) + 'B';
    } else if (bytes < 1024 * 1024) {
        return Math.ceil(bytes / 1024) + ' KB';
    } else if (bytes < 1024 * 1024 * 1024) {
        return Math.ceil(bytes / (1024 * 1024)) + ' MB';
    } else if (bytes < 1024 * 1024 * 1024 * 1024) {
        return Math.ceil(bytes / (1024 * 1024 * 1024)) + ' GB';
    } else {
        return Math.ceil(bytes / (1024 * 1024 * 1024 * 1024)).toFixed(2) + ' TB';
    }
};

export const matchWithRegex = (subject, regex) => {
    // Create a regular expression object
    const regexObj = new RegExp(regex);

    // Test if the subject matches the regex
    return regexObj.test(subject);
};
export const getNameFromResponseTemplateKey = (key) => {
    let nameKey = key.replaceAll('public/response-templates/', '');
    nameKey = nameKey.replaceAll('public/enquiry-response/', '');
    nameKey = nameKey.replaceAll('public/announcements/', '');
    return nameKey;
};

export const convertToImage = (element, isView) => {
    if (element) {
        html2canvas(element).then((canvas) => {
            // Convert the canvas to a data URL
            const imgData = canvas.toDataURL('image/png');
            // Create a Blob from the data URL
            const blob = dataURItoBlob(imgData);

            // Use file-saver to trigger the download
            saveAs(blob, 'poll.png');
        });
    }
};
export const handleCopyImageToClipboard = async (element, widthOfTitle, height) => {
    try {
        if (element) {
            html2canvas(element, { removeContainer: true, width: widthOfTitle, height: height }).then(async (canvas) => {
                // Convert the canvas to a data URL
                const imgData = canvas.toDataURL('image/png');

                // Create a Blob from the data URL
                const blob = dataURItoBlob(imgData);

                await navigator.clipboard.write([
                    new ClipboardItem({
                        [blob.type]: blob
                    })
                ]);
            });
        }
    } catch (err) {
        console.error(err.name, err.message);
    }
};

export const downloadCSV = (csvContentData, csvContentHeader) => {
    if (csvContentHeader) {
        let csvContent = 'data:text/csv;charset=utf-8,';

        // Header row
        csvContent += `${csvContentHeader}\n`;

        // Data rows
        csvContent += `${csvContentData}\n`;

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'data.csv');
        document.body.appendChild(link);
        link.click();
    }
};

export const makeCsvHeader = (csvHeaders) => {
    return csvHeaders.join(',');
};

export const makeCsvContent = (csvContents) => {
    return csvContents.join(',');
};
// Function to convert data URL to Blob
function dataURItoBlob(dataURI) {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
}

export const validatePassword = (value) => {
    let errors = '';

    // Check for at least 8 characters
    if (value.length < 8) {
        errors += 'Be at least 8 character long.\n';
    }

    // Check for at least 1 uppercase character and Check for at least 1 lowercase character
    if (!/[A-Z]/.test(value) || !/[a-z]/.test(value)) {
        errors += 'Have 1 uppercase  and 1 lowercase letter.\n';
    }

    // Check for at least 1 number
    if (!/\d/.test(value)) {
        errors += 'Have 1 number.\n';
    }

    // Check for at least 1 special character
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
        errors += 'Have 1 special character.';
    }

    return errors;
};
export const getFullName = (user) => {
    if (user?.firstName || user?.lastName) return `${user?.firstName || ''} ${user?.lastName || ''}`;
    else return '';
};

export const getLinksFromText = (text) => {
    const linkRegex = /(?:https?|ftp):\/\/\S+|www\.\S+/gi;
    const links = text.match(linkRegex) || [];
    return links;
};

export const exportToPdf = (input, fileName = 'Investor-sentiment-summary.pdf', iconsNode) => {
    const inputHeight = input?.clientHeight;
    const inputWidth = input?.clientWidth;
    if (iconsNode) iconsNode.style.visibility = 'hidden';
    const pdf = new JsPDF({
        format: [inputWidth, inputHeight], // Set the page size to match the content
        unit: 'px', // Use pixels as the unit
        orientation: 'portrait'
    });
    let height = pdf.internal.pageSize.height;
    let pageHeightInPixels = inputHeight;
    let pages = pageHeightInPixels / height;
    // const roundOff = Number(pages.toString().split('.')[1].substring(0, 1));
    // const pageNo = roundOff > 0 ? pages + 1 : pages;
    let pageCount = pages;
    html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL(PDF_CONSTANTS.TYPE);
        // origin
        for (let i = 1; i <= pageCount; i++) {
            let pdfStartingHeight = height * (i - 1);
            pdf.addImage(
                imgData,
                PDF_CONSTANTS.IMAGE_EXTENSION,
                0,
                pdfStartingHeight,
                inputWidth, // * 0.70,
                inputHeight //* 0.8
            );
            if (i < pageCount) {
                pdf.addPage();
            }
        }
        pdf.save(fileName);
        if (iconsNode) iconsNode.style.visibility = 'visible';
    });
};
export const handleExportToPDF = (modalNode, fileName) => {
    if (modalNode) {
        html2pdf().from(modalNode).save(fileName);
    } else {
        console.error('Modal content not found.');
    }
};

export const generateAndUploadPDF = async (containerRef) => {
    // Get the container element
    const container = containerRef;

    // Exclude elements if needed

    // Generate PDF
    const pdf = await html2pdf().from(container).outputPdf();
    const pdfBlob = new Blob([pdf], { type: 'application/pdf' });
    // const fileName = `Investor-sentiment-summary-${new Date().getTime()}.pdf`;
    // // Upload PDF to S3
    // const pdfFile = new File([pdfBlob], fileName, { type: 'application/pdf' });

    // Upload PDF to S3
    return pdfBlob;

    // Optionally, you can display a success message or perform other actions
};
export const generateImageBlob = async (htmlElement) => {
    try {
        // Use html2canvas to capture the content of the HTML element
        const canvas = await html2canvas(htmlElement);

        // Convert the canvas to a blob
        return new Promise((resolve) => {
            canvas.toBlob((blob) => {
                resolve(blob);
            });
        });
    } catch (error) {
        console.error('Error generating image blob:', error);
        throw error;
    }
};
export const addDotIfMissing = (text) => {
    // Check if the text ends with a period (.)
    if (text.endsWith('.')) {
        return text; // If it ends with a period, return the text as it is
    } else {
        return text + '.'; // If it doesn't end with a period, add one at the end
    }
};

export const checkHttps = (url) => {
    if (url.includes('https')) {
        return true;
    } else return false;
};

export const convertSize = (sizeInKB) => {
    if (sizeInKB < 1024) {
        return getRound(sizeInKB) + ' KB';
    } else if (sizeInKB < 1024 * 1024) {
        // Convert to MB
        const sizeInMB = sizeInKB / 1024;
        return getRound(sizeInMB) + ' MB';
    } else if (sizeInKB < 1024 * 1024 * 1024) {
        // Convert to GB
        const sizeInGB = sizeInKB / (1024 * 1024);
        return getRound(sizeInGB) + ' GB';
    } else {
        // Convert to TB or larger units if needed
        const sizeInTB = sizeInKB / (1024 * 1024 * 1024);
        return getRound(sizeInTB) + ' TB';
    }
};
export const giveSize = (key) => {
    const splittedKey = key.split('.');
    const fileType = splittedKey[splittedKey.length - 1];
    if (fileType.toLowerCase() !== 'mp4') {
        // Convert fileSize to bytes for comparison (1GB = 1024MB, 1MB = 1024KB, 1KB = 1024 Bytes)
        const maxSizeBytes = 50; // 4GB in bytes
        return maxSizeBytes;
    } else {
        // Convert fileSize to bytes for comparison (1MB = 1024KB, 1KB = 1024 Bytes)
        const maxSizeBytes = 4096;
        return maxSizeBytes;
    }
};

export const checkSizeGreaterThan50Mb = (size) => {
    const fileSizeLimitBytes = 50 * 1024 * 1024;
    if (size > fileSizeLimitBytes) {
        return true;
    } else {
        return false;
    }
};

export const truncateFilename = (filename, maxLength) => {
    if (filename.length <= maxLength) {
        return filename;
    } else {
        var namePart = filename.substring(0, maxLength - 4); // 4 characters reserved for file extension (.mp4)
        var extensionPart = filename.substring(filename.length - 4); // Assuming file extension is always 3 characters (.mp4)
        return namePart + '...' + extensionPart;
    }
};

export const escapeQuotes = (str) => {
    return str.replace(/"/g, '""');
};

export const isValidURL = (url) => {
    const regex = new RegExp(
        '^(https?:\\/\\/|ftp:\\/\\/|www\\.)?' + // protocol
            '(([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)*' + // subdomains
            '([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.' + // domain name
            '[a-zA-Z]{2,}' + // top-level domain
            '(:\\d+)?' + // port
            '(\\/[-a-zA-Z\\d%_.~+]*)*' + // path
            '(\\?[;&a-zA-Z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-zA-Z\\d_]*)?$',
        'i' // fragment locator
    );
    return !!regex.test(url);
};

export const classifyLinkType = (url) => {
    const hostname = url.toLowerCase();
    if (/facebook\.com/.test(hostname)) {
        return 'facebook';
    } else if (/instagram\.com/.test(hostname)) {
        return 'instagram';
    } else if (/linkedin\.com/.test(hostname)) {
        return 'linkedin';
    } else if (/twitter\.com|x\.com/.test(hostname)) {
        return 'twitter';
    } else if (/youtube\.com/.test(hostname)) return 'youtube';
    else {
        return 'other';
    }
};

export const embedHttpsIfUrlDoesnotHaveIt = (url) => (url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`);
